import Model from 'braindamage/model'
import DodoneSchema from 'generated/schemas/dodone'

class Dodone extends Model {
  static schema = DodoneSchema
  static modelName = 'Dodone'

  // Fill-in your attribute overrides
  static attributesDefinitions() {
    return {
      children: {
        name: 'children',
        apiName: 'children',
        camelName: 'children',
        underscoreName: 'children',
        type: 'has_many',
        model: 'Dodone',
        default: []
      }
    }
  }

  isPrevious() {
    const todayStartUTC = new Date()
    todayStartUTC.setUTCHours(0, 0, 0, 0)

    return this.day < todayStartUTC
  }

  itemClassName({ size = 'md' }) {
    return `dodone-list-item dodone-list-item-${size} dodone-list-item-${this.status}`
  }
}

export default Dodone.define()
